export default __webpack_public_path__ + "static/media/nature_white_female.090d65d9.png";